// ============================================================================
// MarketStatusChip — статус заявки (подпись из перечисления базы).
// Оформление — только по известным кодам MktRequestStatus; неизвестный код
// показывается нейтрально и БЕЗ выдуманной подписи.
// ============================================================================

import { cn } from '@/lib/utils';

const STATUS_CLASSES: Record<string, string> = {
  new: 'bg-sky-500/12 text-sky-700 border-sky-500/30',
  taken: 'bg-amber-500/12 text-amber-700 border-amber-500/30',
  in_progress: 'bg-violet-500/12 text-violet-700 border-violet-500/30',
  done: 'bg-emerald-500/12 text-emerald-700 border-emerald-500/30',
  canceled: 'bg-muted text-muted-foreground border-border',
  expired: 'bg-slate-500/12 text-slate-700 border-slate-500/30',
};

export function MarketStatusChip({ status, label }: { status: string; label: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium leading-4',
        STATUS_CLASSES[status] || 'bg-muted text-muted-foreground border-border',
      )}
    >
      {label || status || 'Без статуса'}
    </span>
  );
}

export function isFinalMarketStatus(status: string): boolean {
  return status === 'done' || status === 'canceled' || status === 'expired';
}
